// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"_6a1PA-xVdZQk8750vfhkg","policyTable":"_3coI7OTL1uRF8NYYKtkaNP"};